export const CommonReducerKey = 'CommonReducer';
export const SettingReducerKey = 'SettingReducer';
export const TranslationReducerKey = 'TranslationReducer';